/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const setDemandStatusRequestSchema = z.object({
  demandStatusId: z.int(),
});
